import { Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { RestService } from '../communication-rest/communication-rest.service';
import { urlServicesGlobalCat } from '../../constants/global-cat.constants';
import { CatalogDto } from '../../models/generic/catalog.dto';
import { HttpErrorCodeService } from '../../shared/error/http-error-code';

@Injectable({
  providedIn: 'root'
})
export class TranslateService {
  private translations: any = {};

  constructor(protected restService: RestService){}

  loadTranslationsLogin() : Observable<CatalogDto[]>{
    return this.restService.get<any>(urlServicesGlobalCat.lanLogin, true).pipe(
      map(res => {
        let listLang: CatalogDto[] = [];
        if (Array.isArray(res)) {
          res.forEach((element: any, index: number) => {
            var obj : CatalogDto = {
              catalogId : index + 1,
              catalogValue : element.languageCve,
              catalogDescription : element.language,
              catalogStatus : '',
              catalogJson: element.labels,
              catalogType: element.type
            }
            listLang.push(obj);
          });            
        }
        return listLang;
      }),
      catchError((error) => {
        throw HttpErrorCodeService.getMessage(error);
      })      
    );
  }

  private loadTranslations(lang: string): Observable<any> {
    return this.restService.get(urlServicesGlobalCat.lanLogin, true);
  }


  setLanguage(lang: string): void {
    this.loadTranslations(lang).subscribe((translations: any) => {
      this.translations = translations;
    });
  }

  translate(key: string): string {
    return this.translations[key] || key;
  }
}